import React from "react";
import {Col, Row} from "antd";
import IWidgetProps from "../../../../model/interface/widget/IWidgetProps";
import IColumnOptions from "../../../../model/interface/widget/option/IColumnOptions";
import Widget from "./Widget";
import IWidget from "../../../../model/interface/widget/IWidget";
import IWidgetPropsFunctions from "../../../../model/interface/widget/IWidgetPropsFunctions";
import {IAppState} from "../../../../redux/store";
import {connect} from "react-redux";
import {MARGIN_SIZES} from "../../../../redux/constants/Theme";

interface IProps extends IWidgetProps<IWidgetPropsFunctions<IWidget<IColumnOptions>>>{
    margin: string
}

class ColumnsWidget extends React.Component<IProps, IColumnOptions> {
    render() {
        const {id, functions, margin} = this.props
        const children = functions.getSortedChildren(id)

        return (
            <div>
                {children.length > 0 && (
                    <Row gutter={[MARGIN_SIZES[margin] * 1.33, MARGIN_SIZES[margin] * 1.33]}>
                        {functions.getSortedChildren(id).map(child => {
                            return (
                                <Col key={child.id}
                                     sm={child.options.width ? Number(child.options.width) : 24}>
                                    <Widget
                                        {...this.props}
                                        {...child}
                                        id={child.id}
                                        key={child.id}
                                    />
                                </Col>
                            )
                        })}
                    </Row>
                )}
            </div>
        );
    }
}


const mapStateToProps = ({theme}: IAppState) => {
    const {margin} = theme;
    return {margin}
}

export default connect(mapStateToProps)(ColumnsWidget)